// DTF Configurator — Shopify port
// Reads config from window.DTF_CONFIG (set by sections/dtf-configurator.liquid)
// R2-migration hotfix — findVariant handles Shopify's options-as-objects format
(function () {
  const CFG = window.DTF_CONFIG || {};

  let currentStep = 0;
  let uploadedFile = null;
  let uploadedDataURL = null;  // local preview only
  let uploadedRemoteURL = null; // R2 public URL — attached to Shopify cart line item
  let uploadedW = 0, uploadedH = 0;
  let selectedOpts = { shirt: true, gang: false };
  let selectedSize = 'S';
  const GARMENTS = (CFG.garments && CFG.garments.length) ? CFG.garments
                  : (CFG.colors || []).map(c => ({ brand: 'Legacy', colorName: c.name, hex: c.hex, image: null, chestX: 35, chestY: 28, chestW: 30, chestH: 22 }));
  let currentBrand = (GARMENTS[0] && GARMENTS[0].brand) || 'Gildan 5000 Unisex';
  let currentGarment = GARMENTS.find(g => g.brand === currentBrand) || GARMENTS[0] || null;
  let shirtColor = currentGarment ? currentGarment.hex : '#1a1a1a';
  let shirtColorName = currentGarment ? currentGarment.colorName : 'Black';
  let currentAngle = 'front';

  let shirtProduct = null;
  let gangProduct = null;

  // ── DOM HELPERS ───────────────────────────────────────
  const $ = (id) => document.getElementById(id);

  // ── PRODUCTS (load variants for cart submit) ──────────
  async function loadProducts() {
    if (CFG.shirtProductHandle) {
      try {
        const res = await fetch(`/products/${CFG.shirtProductHandle}.js`);
        if (res.ok) shirtProduct = await res.json();
      } catch (e) { console.warn('Shirt product load failed:', e); }
    }
    if (CFG.gangProductHandle) {
      try {
        const res = await fetch(`/products/${CFG.gangProductHandle}.js`);
        if (res.ok) gangProduct = await res.json();
      } catch (e) { console.warn('Gang product load failed:', e); }
    }
  }

  function findVariant(product, optionsMap) {
    if (!product || !product.variants) return null;
    // Shopify's /products/{handle}.js returns options as [{name, position, values}]
    // or occasionally as bare strings depending on the API version — support both.
    const optNames = (product.options || []).map(o => typeof o === 'string' ? o : (o && o.name) || '');
    return product.variants.find(v => {
      return optNames.every((optName, i) => {
        if (!optName) return true;
        const want = optionsMap[optName.toLowerCase()];
        if (want == null) return true;
        return String((v.options || [])[i]).toLowerCase() === String(want).toLowerCase();
      });
    }) || product.variants[0];
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── UPLOAD ────────────────────────────────────────────
  function setupUpload() {
    const fileInput = $('fileInput');
    const uploadZone = $('uploadZone');
    if (!fileInput || !uploadZone) return;

    uploadZone.addEventListener('dragover', e => { e.preventDefault(); uploadZone.classList.add('dragover'); });
    uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('dragover'));
    uploadZone.addEventListener('drop', e => {
      e.preventDefault();
      uploadZone.classList.remove('dragover');
      if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    });
    fileInput.addEventListener('change', e => { if (e.target.files[0]) handleFile(e.target.files[0]); });
  }

  // Detect the tight bounding box of non-transparent pixels and return a
  // trimmed dataURL + dimensions. Falls back to original on error.
  function trimTransparentImg(img) {
    try {
      const c = document.createElement('canvas');
      c.width = img.naturalWidth; c.height = img.naturalHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const data = ctx.getImageData(0, 0, c.width, c.height).data;
      let minX = c.width, minY = c.height, maxX = -1, maxY = -1;
      for (let y = 0; y < c.height; y++) {
        for (let x = 0; x < c.width; x++) {
          if (data[(y * c.width + x) * 4 + 3] > 8) {
            if (x < minX) minX = x; if (x > maxX) maxX = x;
            if (y < minY) minY = y; if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return { dataURL: null, width: c.width, height: c.height, trimmed: false };
      const w = maxX - minX + 1, h = maxY - minY + 1;
      const slack = 1 - (w * h) / (c.width * c.height);
      if (slack < 0.02) return { dataURL: null, width: c.width, height: c.height, trimmed: false };
      const out = document.createElement('canvas');
      out.width = w; out.height = h;
      out.getContext('2d').drawImage(c, minX, minY, w, h, 0, 0, w, h);
      return { dataURL: out.toDataURL('image/png'), width: w, height: h, trimmed: true };
    } catch (e) {
      console.warn('trim failed', e);
      return { dataURL: null, width: img.naturalWidth, height: img.naturalHeight, trimmed: false };
    }
  }

  async function handleFile(file) {
    if (!file.type.startsWith('image/') && file.type !== 'application/pdf') {
      alert('Please upload an image or PDF (PNG, JPG, SVG, WebP, PDF).');
      return;
    }
    if (file.size > 200 * 1024 * 1024) {
      alert('File size must be less than 200 MB.');
      return;
    }

    uploadedFile = file;

    // Local preview via FileReader for non-PDF images
    if (file.type.startsWith('image/') && file.type !== 'image/svg+xml') {
      const reader = new FileReader();
      reader.onload = e => {
        uploadedDataURL = e.target.result;
        const img = new Image();
        img.onload = async () => {
          // Trim transparent margins so dimensions reflect visible art only.
          const trim = trimTransparentImg(img);
          if (trim.trimmed && trim.dataURL) uploadedDataURL = trim.dataURL;
          uploadedW = trim.width;
          uploadedH = trim.height;
          const DPI = 300;
          const widthIn = trim.width / DPI;
          const heightIn = trim.height / DPI;
          $('thumbImg').src = uploadedDataURL;
          $('imgName').textContent = file.name;
          $('imgDims').innerHTML =
            `${trim.width} × ${trim.height}px  ·  <strong style="color:var(--accent2)">${widthIn.toFixed(2)}" × ${heightIn.toFixed(2)}"</strong> @ 300 DPI` +
            (trim.trimmed ? ` · <span style="color:var(--muted);">trimmed</span>` : '');
          $('imgSize').textContent = fmtBytes(file.size);
          $('imageInfo').classList.add('visible');
          if (currentStep >= 1) await buildPreviews();
        };
        img.src = uploadedDataURL;
      };
      reader.readAsDataURL(file);
    } else {
      // PDF / SVG fallback
      uploadedDataURL = null;
      $('thumbImg').removeAttribute('src');
      $('imgName').textContent = file.name;
      $('imgDims').textContent = file.type === 'application/pdf' ? 'PDF' : 'SVG';
      $('imgSize').textContent = fmtBytes(file.size);
      $('imageInfo').classList.add('visible');
    }

    // Upload is deferred to Add to Cart
  }

  const UPLOAD_WORKER_URL = 'https://txdtf-upload.txdtfprinting.workers.dev/sign-upload';

  async function uploadToR2(file) {
    const progEl = $('uploadProgress');
    const progFill = $('uploadProgressFill');
    const progText = $('uploadProgressText');
    if (progEl) progEl.classList.add('visible');
    if (progText) progText.textContent = 'Requesting upload URL…';
    if (progFill) progFill.style.width = '0%';

    const signRes = await fetch(UPLOAD_WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        size: file.size
      })
    });
    if (!signRes.ok) {
      const err = await signRes.json().catch(() => ({ error: signRes.statusText }));
      if (progText) progText.textContent = `⚠ ${err.error || 'Failed to prepare upload'}`;
      throw new Error(err.error || 'Failed to prepare upload');
    }
    const { uploadUrl, publicUrl } = await signRes.json();

    if (progText) progText.textContent = 'Uploading design…';

    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl);
      xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
      xhr.upload.onprogress = e => {
        if (e.lengthComputable) {
          const pct = (e.loaded / e.total) * 100;
          if (progFill) progFill.style.width = pct.toFixed(0) + '%';
          if (progText) progText.textContent = `Uploading design… ${pct.toFixed(0)}%`;
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          if (progFill) progFill.style.width = '100%';
          if (progText) progText.textContent = '✓ Uploaded';
          resolve();
        } else {
          if (progText) progText.textContent = `⚠ Upload failed (${xhr.status})`;
          reject(new Error(`Upload failed: ${xhr.status}`));
        }
      };
      xhr.onerror = () => {
        if (progText) progText.textContent = '⚠ Network error during upload';
        reject(new Error('Network error'));
      };
      xhr.send(file);
    });

    uploadedRemoteURL = publicUrl;
    setTimeout(() => { if (progEl) progEl.classList.remove('visible'); }, 1500);
    return publicUrl;
  }

  function clearImage() {
    uploadedFile = null;
    uploadedDataURL = null;
    uploadedRemoteURL = null;
    uploadedW = uploadedH = 0;
    const fi = $('fileInput'); if (fi) fi.value = '';
    $('imageInfo').classList.remove('visible');
    const progEl = $('uploadProgress'); if (progEl) progEl.classList.remove('visible');
  }
  window.dtfClearImage = clearImage;

  function fmtBytes(b) {
    if (b < 1024) return b + ' B';
    if (b < 1048576) return (b / 1024).toFixed(1) + ' KB';
    return (b / 1048576).toFixed(2) + ' MB';
  }

  // ── PRODUCT TOGGLE ────────────────────────────────────
  function toggleOpt(type) {
    selectedOpts[type] = !selectedOpts[type];
    const el = type === 'shirt' ? $('optShirt') : $('optGang');
    el.classList.toggle('selected', selectedOpts[type]);
    updateSummary();
  }
  window.dtfToggleOpt = toggleOpt;

  // ── NAVIGATION ────────────────────────────────────────
  function goToStep(n) { if (n < currentStep) setStep(n); }
  window.dtfGoToStep = goToStep;

  async function nextStep() {
    if (currentStep === 0) {
      updateSummary();
    }
    if (currentStep === 1) {
      if (!uploadedFile) {
        alert('Please upload your design first.');
        const zone = $('uploadZone');
        if (zone) { zone.classList.add('needs-attention'); setTimeout(() => zone.classList.remove('needs-attention'), 2000); }
        return;
      }
      try { await buildPreviews(); }
      catch (e) { alert('Error building preview: ' + e.message); return; }
      updateSummary();
    }
    if (currentStep < 2) setStep(currentStep + 1);
  }
  window.dtfNextStep = nextStep;

  function prevStep() { if (currentStep > 0) setStep(currentStep - 1); }
  window.dtfPrevStep = prevStep;

  function setStep(n) {
    currentStep = n;
    document.querySelectorAll('.panel').forEach((p, i) => p.classList.toggle('active', i === n));
    const ps = $('panelSuccess'); if (ps) ps.classList.remove('active');
    [0, 1, 2].forEach(i => {
      const el = $('stab' + i);
      if (!el) return;
      el.classList.toggle('active', i === n);
      el.classList.toggle('done', i < n);
    });
    if ($('colorRow')) $('colorRow').style.display = selectedOpts.shirt ? 'flex' : 'none';
    if ($('shirtCard')) $('shirtCard').style.display = selectedOpts.shirt ? 'block' : 'none';
    if ($('gangCard')) $('gangCard').style.display = selectedOpts.gang ? 'block' : 'none';
    if ($('shirtOpts')) $('shirtOpts').style.display = selectedOpts.shirt ? 'block' : 'none';
    if ($('gangOpts')) $('gangOpts').style.display = selectedOpts.gang ? 'block' : 'none';
    const anchor = $('dtfConfigurator');
    if (anchor) window.scrollTo({ top: anchor.offsetTop - 20, behavior: 'smooth' });
  }

  // ── COLOR HELPERS ─────────────────────────────────────
  function hex2rgb(h) { return { r: parseInt(h.slice(1, 3), 16), g: parseInt(h.slice(3, 5), 16), b: parseInt(h.slice(5, 7), 16) }; }
  function hex2hsl(hex) {
    const { r: R, g: G, b: B } = hex2rgb(hex);
    const r = R / 255, g = G / 255, b = B / 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s = 0; const l = (max + min) / 2;
    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    return { h, s, l };
  }
  function hsl2css({ h, s, l }) { return `hsl(${h.toFixed(1)},${(s * 100).toFixed(1)}%,${(l * 100).toFixed(1)}%)`; }
  function shade(hex, dl) { const hsl = hex2hsl(hex); hsl.l = Math.max(0, Math.min(1, hsl.l + dl)); return hsl2css(hsl); }

  // ── SHIRT SVG ─────────────────────────────────────────
  function buildShirtSVG(color, view) {
    const baseL = hex2hsl(color).l;
    const hlAmt = baseL > 0.85 ? 0.04 : baseL > 0.55 ? 0.10 : 0.18;
    const shAmt = baseL < 0.12 ? 0.06 : baseL < 0.35 ? 0.10 : 0.18;
    const cHL = shade(color, hlAmt + 0.06);
    const cL = shade(color, hlAmt);
    const cD = shade(color, -shAmt);
    const cS = shade(color, -shAmt - 0.07);
    const cS2 = shade(color, -shAmt - 0.14);

    if (view === 'fold') {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="360" viewBox="0 0 300 360">
        <defs>
          <filter id="sh" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="5"/><feOffset dx="0" dy="6"/>
            <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
            <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
          </filter>
          <radialGradient id="foldBody" cx="50%" cy="38%" r="68%">
            <stop offset="0%" stop-color="${cHL}"/><stop offset="40%" stop-color="${cL}"/>
            <stop offset="75%" stop-color="${color}"/><stop offset="100%" stop-color="${cD}"/>
          </radialGradient>
          <linearGradient id="foldTopShade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="${cD}" stop-opacity="0.35"/><stop offset="100%" stop-color="${cD}" stop-opacity="0"/>
          </linearGradient>
          <linearGradient id="foldBotShade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="${cS}" stop-opacity="0"/><stop offset="100%" stop-color="${cS}" stop-opacity="0.35"/>
          </linearGradient>
        </defs>
        <ellipse cx="150" cy="332" rx="118" ry="9" fill="rgba(0,0,0,0.35)"/>
        <rect x="50" y="60" width="200" height="260" rx="9" ry="9" fill="url(#foldBody)" filter="url(#sh)"/>
        <rect x="50" y="60" width="200" height="50" rx="9" fill="url(#foldTopShade)"/>
        <rect x="50" y="270" width="200" height="50" rx="9" fill="url(#foldBotShade)"/>
        <path d="M50,108 L96,108 L80,150 L50,160 Z" fill="${cD}" opacity="0.55"/>
        <path d="M250,108 L204,108 L220,150 L250,160 Z" fill="${cD}" opacity="0.55"/>
        <path d="M132,60 Q132,46 150,42 Q168,46 168,60 L168,72 Q150,76 132,72 Z" fill="${cS}"/>
        <path d="M134,60 Q150,68 166,60" fill="none" stroke="${cS2}" stroke-width="2" stroke-linecap="round"/>
        <path d="M58,62 Q150,58 242,62" stroke="${cHL}" stroke-width="1" fill="none" opacity="0.4"/>
        <line x1="150" y1="110" x2="150" y2="318" stroke="${cD}" stroke-width="1" opacity="0.18"/>
        <path d="M52,193 Q150,197 248,193" stroke="${cD}" stroke-width="1.2" fill="none" opacity="0.32"/>
        <line x1="54" y1="316" x2="246" y2="316" stroke="${cS}" stroke-width="1.6" opacity="0.55"/>
      </svg>`;
    }

    return `<svg xmlns="http://www.w3.org/2000/svg" width="300" height="360" viewBox="0 0 300 360">
      <defs>
        <filter id="sh" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="5"/><feOffset dx="0" dy="6"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id="gBody" cx="50%" cy="30%" r="62%">
          <stop offset="0%" stop-color="${cHL}"/><stop offset="30%" stop-color="${cL}"/>
          <stop offset="65%" stop-color="${color}"/><stop offset="92%" stop-color="${cD}"/>
          <stop offset="100%" stop-color="${cS}"/>
        </radialGradient>
        <linearGradient id="gSleeveL" x1="0" y1="0" x2="1" y2="0.4">
          <stop offset="0%" stop-color="${cS}"/><stop offset="55%" stop-color="${cD}"/><stop offset="100%" stop-color="${color}"/>
        </linearGradient>
        <linearGradient id="gSleeveR" x1="1" y1="0" x2="0" y2="0.4">
          <stop offset="0%" stop-color="${cS}"/><stop offset="55%" stop-color="${cD}"/><stop offset="100%" stop-color="${color}"/>
        </linearGradient>
        <radialGradient id="gNeckHole" cx="50%" cy="20%" r="80%">
          <stop offset="0%" stop-color="${cS2}"/><stop offset="100%" stop-color="${cD}"/>
        </radialGradient>
        <linearGradient id="centerHL" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="${cHL}" stop-opacity="0.30"/><stop offset="55%" stop-color="${cHL}" stop-opacity="0.08"/><stop offset="100%" stop-color="${cHL}" stop-opacity="0"/>
        </linearGradient>
      </defs>
      <ellipse cx="150" cy="346" rx="125" ry="9" fill="rgba(0,0,0,0.35)"/>
      <path d="M80,52 Q48,58 26,95 Q14,138 32,162 Q58,170 92,160 L92,75 Z" fill="url(#gSleeveL)" filter="url(#sh)"/>
      <path d="M220,52 Q252,58 274,95 Q286,138 268,162 Q242,170 208,160 L208,75 Z" fill="url(#gSleeveR)" filter="url(#sh)"/>
      <path d="M44,90 Q38,118 42,150" stroke="${cHL}" stroke-width="2" fill="none" opacity="0.35"/>
      <path d="M256,90 Q262,118 258,150" stroke="${cHL}" stroke-width="2" fill="none" opacity="0.35"/>
      <path d="M32,162 Q60,170 92,160" stroke="${cS}" stroke-width="2" fill="none" opacity="0.55"/>
      <path d="M208,160 Q240,170 268,162" stroke="${cS}" stroke-width="2" fill="none" opacity="0.55"/>
      <path d="M80,52 Q75,68 80,80 Q78,200 70,335 Q78,340 230,340 Q222,200 220,80 Q225,68 220,52 Q200,38 178,40 Q175,52 168,58 Q158,64 150,64 Q142,64 132,58 Q125,52 122,40 Q100,38 80,52 Z" fill="url(#gBody)" filter="url(#sh)"/>
      <ellipse cx="150" cy="180" rx="36" ry="105" fill="url(#centerHL)"/>
      <path d="M122,40 Q125,52 132,58 Q142,64 150,64 Q158,64 168,58 Q175,52 178,40 Q165,34 150,34 Q135,34 122,40 Z" fill="url(#gNeckHole)"/>
      <path d="M122,40 Q125,52 132,58 Q150,67 168,58 Q175,52 178,40" fill="none" stroke="${cS2}" stroke-width="2.5" stroke-linecap="round" opacity="0.85"/>
      <path d="M92,75 Q108,66 122,72" stroke="${cD}" stroke-width="1.5" fill="none" opacity="0.5"/>
      <path d="M208,75 Q192,66 178,72" stroke="${cD}" stroke-width="1.5" fill="none" opacity="0.5"/>
      <path d="M88,80 Q80,200 74,335" stroke="${cD}" stroke-width="1" fill="none" opacity="0.3"/>
      <path d="M212,80 Q220,200 226,335" stroke="${cD}" stroke-width="1" fill="none" opacity="0.3"/>
      <path d="M70,335 Q150,343 230,335" fill="none" stroke="${cS}" stroke-width="1.8" opacity="0.6"/>
    </svg>`;
  }

  function svgToImg(svgStr) {
    return new Promise(res => {
      const blob = new Blob([svgStr], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      const img = new Image();
      img.onload = () => { URL.revokeObjectURL(url); res(img); };
      img.src = url;
    });
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  const printAreas = {
    front: { px: 0.30, py: 0.27, pw: 0.40, ph: 0.40 },
    fold: { px: 0.24, py: 0.34, pw: 0.52, ph: 0.32 }
  };

  async function tryLoadMockup(url) {
    return new Promise(resolve => {
      const test = new Image();
      test.onload = () => resolve(true);
      test.onerror = () => resolve(false);
      test.src = url;
    });
  }

  async function renderMockupInto(imgId, canvasId) {
    const img = $(imgId);
    const canvas = $(canvasId);
    if (!img && !canvas) return;

    const useCanvas = async () => {
      if (img) img.style.display = 'none';
      if (canvas) {
        canvas.style.display = 'block';
        const ctx = canvas.getContext('2d');
        const W = 300, H = 360;
        canvas.width = W; canvas.height = H;
        ctx.clearRect(0, 0, W, H);
        try {
          const svgStr = buildShirtSVG(shirtColor, currentAngle);
          const shirtImg = await svgToImg(svgStr);
          ctx.drawImage(shirtImg, 0, 0, W, H);
        } catch (e) { /* ignore */ }
      }
    };

    if (currentGarment && currentGarment.image) {
      const ok = await tryLoadMockup(currentGarment.image);
      if (ok) {
        if (img) { img.src = currentGarment.image; img.style.display = 'block'; }
        if (canvas) canvas.style.display = 'none';
      } else {
        await useCanvas();
      }
    } else {
      await useCanvas();
    }
  }

  async function drawShirtMockup() {
    await renderMockupInto('shirtMockupImg', 'shirtCanvas');
    await renderMockupInto('shirtMockupImg1', 'shirtCanvas1');

    const overlay = $('mockupDesignOverlay');
    const placeholder = $('mockupPlaceholder');
    if (placeholder) placeholder.style.display = 'none';

    if (overlay) {
      const g = currentGarment || { chestX: 35, chestY: 28, chestW: 30, chestH: 22 };
      overlay.style.left   = g.chestX + '%';
      overlay.style.top    = g.chestY + '%';
      overlay.style.width  = g.chestW + '%';
      overlay.style.height = g.chestH + '%';
      if (uploadedDataURL) {
        overlay.innerHTML = `<img src="${uploadedDataURL}" alt="">`;
      } else {
        overlay.innerHTML = `<div class="mdo-placeholder">YOUR DESIGN</div>`;
      }
    }

    if ($('pvShirtBadge') && currentGarment) $('pvShirtBadge').textContent = `${currentGarment.brand} · ${currentGarment.colorName}`;
    if ($('pvColor1') && currentGarment) $('pvColor1').textContent = currentGarment.colorName;
    if ($('pvSize1')) $('pvSize1').textContent = selectedSize;
    if ($('pvQty1')) $('pvQty1').textContent = ($('shirtQty') && $('shirtQty').value) || '1';
  }

  function drawPlaceholder(ctx, W, H) {
    const { px, py, pw, ph } = printAreas[currentAngle];
    const aX = px * W, aY = py * H, aW = pw * W, aH = ph * H;
    ctx.setLineDash([4, 4]);
    ctx.strokeStyle = 'rgba(255,255,255,0.25)';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(aX, aY, aW, aH);
    ctx.setLineDash([]);
    ctx.fillStyle = 'rgba(255,255,255,0.17)';
    ctx.font = 'bold 10px monospace';
    ctx.textAlign = 'center';
    ctx.fillText('YOUR DESIGN HERE', aX + aW / 2, aY + aH / 2);
    ctx.textAlign = 'left';
  }

  async function setAngle(a, btn) {
    currentAngle = a;
    document.querySelectorAll('.abtn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    await drawShirtMockup();
  }
  window.dtfSetAngle = setAngle;

  async function changeColor(el) {
    document.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
    el.classList.add('active');
    const name = el.dataset.name;
    const g = GARMENTS.find(x => x.brand === currentBrand && x.colorName === name);
    if (g) currentGarment = g;
    shirtColor = el.dataset.color;
    shirtColorName = name;
    if ($('pvColor')) $('pvColor').textContent = name;
    if ($('colorNameLabel')) $('colorNameLabel').textContent = name;
    await drawShirtMockup();
    updateSummary();
  }
  window.dtfChangeColor = changeColor;

  function populateBrandSelector() {
    const brandRow = $('brandRow');
    const brandSel = $('brandSelect');
    if (!brandRow || !brandSel) return;
    const brands = [];
    GARMENTS.forEach(g => { if (!brands.includes(g.brand)) brands.push(g.brand); });
    if (brands.length <= 1) {
      brandRow.style.display = 'none';
    } else {
      brandRow.style.display = 'flex';
      brandSel.innerHTML = brands.map(b =>
        `<option value="${b}"${b === currentBrand ? ' selected' : ''}>${b}</option>`
      ).join('');
    }
  }

  function populateSwatches() {
    const wrap = $('swatches');
    if (!wrap) return;
    const list = GARMENTS.filter(g => g.brand === currentBrand);
    wrap.innerHTML = list.map((g, i) => {
      const active = (currentGarment && currentGarment.colorName === g.colorName) ? ' active' : (i === 0 ? ' active' : '');
      const isLight = /^#(fff|ffffff|f[0-9a-f]{5})$/i.test(g.hex);
      return `<div class="swatch${active}" style="background:${g.hex};${isLight ? 'border:1px solid #444;' : ''}"
                   data-color="${g.hex}" data-name="${g.colorName}"
                   title="${g.colorName}"
                   onclick="dtfChangeColor(this)"></div>`;
    }).join('');
    if ($('colorNameLabel') && currentGarment) $('colorNameLabel').textContent = currentGarment.colorName;
  }

  async function changeBrand(brand) {
    currentBrand = brand;
    const first = GARMENTS.find(g => g.brand === brand);
    if (first) {
      currentGarment = first;
      shirtColor = first.hex;
      shirtColorName = first.colorName;
      if ($('pvColor')) $('pvColor').textContent = first.colorName;
    }
    populateSwatches();
    await drawShirtMockup();
    updateSummary();
  }
  window.dtfChangeBrand = changeBrand;

  // ── PREVIEWS ──────────────────────────────────────────
  async function buildPreviews() {
    const shirtCard = $('shirtCard');
    const gangCard = $('gangCard');
    if (selectedOpts.shirt && shirtCard) shirtCard.style.opacity = '0.7';
    if (selectedOpts.gang && gangCard) gangCard.style.opacity = '0.7';

    if (selectedOpts.shirt) {
      await drawShirtMockup();
      if (shirtCard) shirtCard.style.opacity = '1';
    }

    if (selectedOpts.gang) {
      setTimeout(() => {
        const gs = $('gangSheet');
        if (!gs) return;
        gs.innerHTML = '';
        const tileCount = Math.min(12, Math.max(1, Math.floor(22 / Math.max(1, uploadedFile ? 2 : 1))));
        if ($('gangCount')) $('gangCount').textContent = tileCount;
        for (let i = 0; i < tileCount; i++) {
          const cell = document.createElement('div');
          cell.className = 'gang-cell';
          if (uploadedDataURL) {
            const img = document.createElement('img');
            img.src = uploadedDataURL;
            img.style.display = 'block';
            cell.appendChild(img);
          } else {
            cell.innerHTML = '<div class="empty-cell"></div>';
          }
          gs.appendChild(cell);
        }
        if (gangCard) gangCard.style.opacity = '1';
      }, 300);
    }
  }

  // ── SIZE / SUMMARY ────────────────────────────────────
  function pickSize(btn) {
    document.querySelectorAll('.sz-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    selectedSize = btn.textContent.trim();
    updateSummary();
  }
  window.dtfPickSize = pickSize;

  function updateSummary() {
    const SHIPPING = CFG.shippingCents != null ? CFG.shippingCents / 100 : 7.99;
    let total = SHIPPING;
    const colorName = $('pvColor')?.textContent || shirtColorName;

    if (selectedOpts.shirt) {
      const qty = parseInt($('shirtQty')?.value || 1);
      let unitCents = CFG.shirtPriceCents || 2200;
      if (shirtProduct) {
        const v = findVariant(shirtProduct, { size: selectedSize, color: colorName });
        if (v) unitCents = v.price;
      }
      const stotal = (unitCents / 100) * qty;
      total += stotal;
      $('sRow1').style.display = 'flex';
      $('sItem1').textContent = `T-Shirt (${selectedSize}, ${colorName}) × ${qty}`;
      $('sPrice1').textContent = `$${stotal.toFixed(2)}`;
    } else { $('sRow1').style.display = 'none'; }

    if (selectedOpts.gang) {
      const len = parseInt($('gangLen')?.value || 22);
      const qty = parseInt($('gangQty')?.value || 1);
      let baseCents = CFG.gangBasePriceCents || 1400;
      if (gangProduct) {
        const v = findVariant(gangProduct, { length: len + '"', size: len + '"' });
        if (v) baseCents = v.price;
      }
      const mul = len / 22;
      const gtotal = (baseCents / 100) * mul * qty;
      total += gtotal;
      $('sRow2').style.display = 'flex';
      $('sItem2').textContent = `Gang Sheet (${len}") × ${qty}`;
      $('sPrice2').textContent = `$${gtotal.toFixed(2)}`;
    } else { $('sRow2').style.display = 'none'; }

    $('sShip').textContent = `$${SHIPPING.toFixed(2)}`;
    $('sTotal').textContent = `$${total.toFixed(2)}`;
  }
  window.dtfUpdateSummary = updateSummary;

  // ── SUBMIT — Shopify cart/add.js ──────────────────────
  async function submitOrder() {
    if (!uploadedFile) {
      alert('Please upload your design before adding to cart.');
      return;
    }
    const btn = $('placeOrderBtn');

    if (!uploadedRemoteURL) {
      if (btn) { btn.disabled = true; btn.textContent = 'Uploading design…'; }
      try { await uploadToR2(uploadedFile); }
      catch (e) {
        alert('Upload failed: ' + e.message);
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
    }

    if (!shirtProduct) {
      alert('Shirt product not loaded yet. Reload the page and try again.');
      if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
      return;
    }

    const variant = findVariant(shirtProduct, { size: selectedSize, color: shirtColorName });
    if (!variant) {
      alert(`No variant for ${shirtColorName} / ${selectedSize}. Check that the Shopify product has that Color + Size combination.`);
      if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
      return;
    }

    const qty = Math.max(1, parseInt(($('shirtQty') && $('shirtQty').value) || '1'));
    const notes = ($('notes') && $('notes').value) || '';

    const properties = {
      'Design URL': uploadedRemoteURL,
      'Filename': uploadedFile.name,
      'Color': shirtColorName,
      'Size': selectedSize
    };
    if (notes) properties['Notes'] = notes;

    if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: qty, properties }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ description: res.statusText }));
        alert('Could not add to cart: ' + (err.description || err.message || res.statusText));
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
      window.location.href = '/cart';
    } catch (e) {
      alert('Network error: ' + e.message);
      if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
    }
  }
  window.dtfSubmitOrder = submitOrder;

  // ── INIT ──────────────────────────────────────────────
  async function init() {
    setupUpload();
    populateBrandSelector();
    populateSwatches();

    // Seed empty gang sheet
    const gs = $('gangSheet');
    if (gs) {
      for (let i = 0; i < 12; i++) {
        const c = document.createElement('div');
        c.className = 'gang-cell';
        c.innerHTML = '<div class="empty-cell"></div>';
        gs.appendChild(c);
      }
    }

    await loadProducts();
    updateSummary();
    await drawShirtMockup();

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'INPUT') {
        if (currentStep < 2) { e.preventDefault(); nextStep(); }
      } else if (e.key === 'Escape') {
        if (currentStep > 0) prevStep();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Generic page helpers
window.backToTopInit = function () {
  const btn = document.getElementById('backToTop');
  if (!btn) return;
  window.addEventListener('scroll', () => {
    btn.classList.toggle('visible', window.scrollY > 500);
  });
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
};
document.addEventListener('DOMContentLoaded', () => window.backToTopInit && window.backToTopInit());
